module.exports = __webpack_public_path__ + "img/131.3.5065a261.png";